import { render, staticRenderFns } from "./ItemN_Ref.vue?vue&type=template&id=010be416"
import script from "./ItemN_Ref.vue?vue&type=script&lang=js"
export * from "./ItemN_Ref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports